import React, { useState, useEffect } from "react";
import api from "../../../services/api";

import ArrowDown from "../../../assets/icons/icon-arrow-down.svg";
import IconZap from '../../../assets/icons/icon-whatsapp.svg';
import IconMap from '../../../assets/icons/icon-markerMap.svg';
import IconEmail from '../../../assets/icons/icon-email.svg';
import IconProfile from '../../../assets/icons/icon-profile.svg';
import IconShare from '../../../assets/icons/icon-share.svg';
import IconTooltip from '../../../assets/icons/icon-phone-gray.png';
import SetaCinzaEsquerda from '../../../assets/icon-left-gray.png';
import { store } from "react-notifications-component";
import Tooltip from "../../tooltip";
import * as S from './styles';
import { TaglineG, TaglineM, TaglineP } from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";
import ButtonList from "../../button-list";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { isTotvs, isOmie } from "../../../services/globalFunctions";

import SelectV2MultiHeaderFarm from "../../select/select_v2_muilti_header_farm";
import ButtonV2 from "../../button/button_v2";

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
export const USER = "@userinfo";

const isMobile = () => {
  const userAgent = navigator.userAgent || window.opera;
  return /android|iphone|ipad|ipod|windows phone/i.test(userAgent);
};

const handleClick = (phone) => {
  if (isMobile()) {
    window.location.href = `tel:${phone}`;
  } else {
    navigator.clipboard.writeText(phone)
      .then(() => store.addNotification({
        title: "Copiado!",
        message: "O Telefone foi copiado com sucesso!",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      }));
  }
};

const FarmHeader = ({ updateCoordinates, updateFarm, setFarmId }) => {
  const [width, setWidth] = useState(window.innerWidth);

  const [fazendas, setFazendas] = useState([]);
  const [farm, setFarm] = useState({ value: 0, label: "" })
  const [coordenadas, setCoordenadas] = useState({ latitude: "", longitude: "" })
  const [phone, setPhone] = useState('');
  const [celular, setCelular] = useState('');
  const [address, setAddress] = useState('');
  const [produtor, setProdutor] = useState(null);
  const [produtorSelect, setProdutorSelect] = useState([]);
  const [produtorId, setProdutorId] = useState('');
  const [produtorEmail, setProdutorEmail] = useState('');

  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const produtorIdFromUrl = Number(pathParts[3]);
  const currentFarmIdFromUrl = Number(pathParts[2]);

  const [loadingSelectMultHeader, setLoadingSelectMultHeader] = useState(false);
  const [loadingRelatorio, setLoadingRelatorio] = useState(false);

  const selecionarCoordenadas = (e) => {
    setCoordenadas(e)
    updateCoordinates(e)
  }

  const convertDMSToDecimal = (dmsString) => {
    if (!dmsString || typeof dmsString !== 'string') {
      return null;
    }

    const dmsRegex = /(\d+)°(\d+)'([\d.]+)"([NSEW])/;
    const match = dmsString.match(dmsRegex);

    if (!match) {
      return null;
    }

    const degrees = parseInt(match[1]);
    const minutes = parseInt(match[2]);
    const seconds = parseFloat(match[3]);
    const direction = match[4];

    let decimal = degrees + (minutes / 60) + (seconds / 3600);

    if (direction === 'S' || direction === 'W') {
      decimal = -decimal;
    }

    return decimal;
  };

  const selectFarm = async (e) => {   
    if (e.value !== farm.value) {
      try {
        const response = await api.get(`/fazendas/${e.value}`);
        const fazenda = response.data.data;
        let { latitude, longitude } = fazenda;
  
        // Converter coordenadas se estiverem no formato DMS
        if (typeof latitude === 'string' && latitude.includes('°')) {
          latitude = convertDMSToDecimal(latitude);
        }
        if (typeof longitude === 'string' && longitude.includes('°')) {
          longitude = convertDMSToDecimal(longitude);
        }
  
        const enderecoCompleto = `${fazenda.endereco}, ${fazenda.bairro}, ${fazenda.numero}, ${fazenda.cidade}-${fazenda.estado}`
  
        if (latitude === '' || latitude === null && longitude === '' || longitude === null) {
          try {
            const result = await geocodeWithGoogleMaps(enderecoCompleto);
            if (result) {
              latitude = result.lat;
              longitude = result.lng;
            }
          } catch (error) {
            const result = await geocodeWithAlternativeAPI(enderecoCompleto);
            if (result) {
              latitude = result.lat;
              longitude = result.lng;
            }
          }
        } 
        setFarm({ value: e.value, label: fazenda.nome });
        
        const agroProducers = fazenda.agro_producers;

        let mainProducer = null;

        if (Array.isArray(agroProducers) && agroProducers.length > 0) {
          mainProducer = agroProducers[0];
        } else if (agroProducers && typeof agroProducers === 'object') {
          mainProducer = agroProducers;
        }

        const produtorNome = mainProducer?.nome || "";
        const produtorIdExterno = mainProducer?.id_externo || "";
        const produtorLegenda = isTotvs() && !isOmie() && produtorIdExterno
          ? `${produtorIdExterno} - ${produtorNome}`
          : produtorNome;

        setProdutor(produtorLegenda);
        setProdutorSelect(fazenda.agro_producers);
        setPhone(fazenda.agro_producers.telefone);
        setCelular(fazenda.agro_producers.celular);
        setAddress(`${fazenda.endereco}, ${fazenda.bairro}, ${fazenda.numero}, ${fazenda.cidade}-${fazenda.estado}`);
        setProdutorEmail(fazenda.agro_producers.email);
        setProdutorId(fazenda.agro_producers.id)
  
        updateFarm(fazenda);
        selecionarCoordenadas({ latitude, longitude });
  
        const novaUrl = `/fazendas/${e.value}/${produtorIdFromUrl}`;
        if (window.location.pathname !== novaUrl) {
          window.location.href = novaUrl;
        }
      } catch (error) {
        console.error('Erro em selectFarm:', error);
      }
    }
  }

  const loadGoogleMapsAPI = () => {
    return new Promise((resolve, reject) => {
      // Verifica se a API já está carregada
      if (window.google && window.google.maps && window.google.maps.Geocoder) {
        resolve();
        return;
      }

      // Remove scripts existentes para evitar conflitos
      const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
      if (existingScript) {
        existingScript.remove();
      }

      // Define callback global para inicialização
      window.initGoogleMaps = () => {
        if (window.google && window.google.maps && window.google.maps.Geocoder) {
          // Limpa o callback global após o uso
          delete window.initGoogleMaps;
          resolve();
        } else {
          delete window.initGoogleMaps;
          reject(new Error('Google Maps API não inicializou corretamente'));
        }
      };

      // Cria e adiciona o script da API com loading=async
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAn3UaVotrho9E6f_BWtW4wDshxnEmM8LI&libraries=places,drawing&loading=async&callback=initGoogleMaps';
      script.async = true;
      script.defer = true;

      script.onerror = () => {
        reject(new Error('Erro ao carregar Google Maps API'));
      };

      // Timeout de segurança
      setTimeout(() => {
        if (window.initGoogleMaps) {
          delete window.initGoogleMaps;
        }
        reject(new Error('Timeout ao carregar Google Maps API'));
      }, 15000);

      document.head.appendChild(script);
    });
  };

  const geocodeWithGoogleMaps = async (endereco) => {
    try {
      await loadGoogleMapsAPI();

      return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: endereco }, (results, status) => {
          if (status === 'OK' && results[0]) {

            const location = results[0].geometry.location;

            const lat = location.lat();
            const lng = location.lng();

            resolve({ lat, lng });
          } else {
            reject(new Error(`Geocoding falhou: ${status}`));
          }
        });
      });
    } catch (error) {
      console.error('Erro ao carregar/usar Google Maps:', error);
      throw error;
    }
  };

  const geocodeWithAlternativeAPI = async (endereco) => {
    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(endereco)}&limit=1`);
      const data = await response.json();

      if (data && data.length > 0) {
        const lat = parseFloat(data[0].lat);
        const lng = parseFloat(data[0].lon);

        return { lat, lng };
      } else {
        return false;
      }
    } catch (error) {
      console.error('Erro na geocodificação alternativa:', error);
      return false;
    }
  };

  const getFazendas = async () => {
    try {
      setLoadingSelectMultHeader(true);
      const response = await api.get('/fazendas?limit=9999999999&offset=0');
      const todasFazendas = response.data.data.fazendas;

      // Filtra só as do produtor que está na URL
      const fazendasFiltradas = todasFazendas.filter(
        (f) => f.agro_producers.id === produtorIdFromUrl
      );

      const options = fazendasFiltradas.map((f) => ({
        value: f.id,
        label: f.nome
      }));

      setFazendas(options);
    } catch (error) {
      console.error("Erro ao carregar fazendas:", error);
    } finally {
      setLoadingSelectMultHeader(false);
    }
  };

  const handleClickRelatorio = async () => {
    setLoadingRelatorio(true);
    window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';
    try {
      const response = await api.get('/relatorios/fazendas');

      if (response.data.downloadUrl) {
        window.open(response.data.downloadUrl);
      }

      store.addNotification({
        title: "Sucesso!",
        message: "Relatório gerado com sucesso.",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 6000, onScreen: true }
      });
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    } finally {
      setLoadingRelatorio(false);
      window.onbeforeunload = null;
    }
  };


  useEffect(() => {
    if (produtorIdFromUrl) {
      getFazendas();
    }
  }, [produtorIdFromUrl]);

  useEffect(() => {
    
    if (setFarmId && setFarmId !== farm.value && setFarmId !== currentFarmIdFromUrl) {
      selectFarm({ value: setFarmId })
    }
  }, [setFarmId, farm.value, currentFarmIdFromUrl])


  const tooltipContentPhone = (
    <div style={{ textAlign: 'left', padding: '10px', maxWidth: '300px' }}>
      <p><strong>Tel:</strong> {phone || 'Não disponível'}</p>
    </div>
  );

  const tooltipContentWhatsApp = (
    <div style={{ textAlign: 'left', padding: '10px', maxWidth: '300px' }}>
      <p><strong>WhatsApp:</strong> {celular || 'Não disponível'}</p>
    </div>
  );

  const tooltipContentLocation = (
    <div style={{ textAlign: 'left', padding: '10px', maxWidth: '300px' }}>
      <p><strong>Endereço:</strong> {address || 'Não disponível'}</p>
    </div>
  );

  const tooltipContentEmail = (
    <div style={{ textAlign: 'left', padding: '10px', maxWidth: '300px' }}>
      <p><strong>Email:</strong> {produtorEmail || 'Não disponível'}</p>
    </div>
  );

  const handleWhatsApp = (phoneNumber) => {
    const formattedNumber = phoneNumber.replace(/\D/g, '');
    const url = `https://wa.me/${formattedNumber}`;
    window.open(url, '_blank');
  };

  const handleGoogleMaps = (address) => {
    const encodedAddress = encodeURIComponent(address);
    const url = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(url, '_blank');
  };

  const handleEmail = () => {
    window.location.href = `mailto:${produtorEmail}`;
  };

  const handleProfile = () => {
    const url = `/produtores/${produtorId}`;
    window.location.href = url;
  };

  const actions = [
    {
      id: 1,
      src: IconZap,
      onClick: () => handleWhatsApp(celular),
      alt: "Ícone de Whatsapp",
      disabled: !celular
    },
    {
      id: 2,
      src: IconMap,
      onClick: () => handleGoogleMaps(address),
      alt: "Ícone Marcador de mapa",
      disabled: !address
    },
    {
      id: 3,
      src: IconEmail,
      onClick: handleEmail,
      alt: "Ícone Envelope",
      disabled: !produtorEmail
    },
    {
      id: 4,
      src: IconProfile,
      onClick: handleProfile,
      alt: "Ícone de Perfil",
      tooltip: 'Dados Produtor'
    }
  ];


  const changeProdutor = (selectedFarm) => {
    setProdutorSelect(selectedFarm);

    if (selectedFarm && selectedFarm.value) {
      selectFarm(selectedFarm);
    }
  }

  useEffect(() => {
    const handleResize = () => {
        setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const urlParts = window.location.pathname.split('/');
  const fazendaId = Number(urlParts[2]); 
  const fazendaSelecionada = fazendas.find(f => f.value === fazendaId);

  return (
    <S.Container>
      <S.Header>
        {width > 760 ? (
          <>
            <S.ContainerButtons>
              {fazendas.length > 0 && (
                <S.ContainerSelect>
                  <ButtonList
                    id="farms"
                    width="100%"
                    legend={produtor}
                    options={fazendas}
                    onSelected={(e) => selectFarm(e)}
                    value={farm}
                  />
                </S.ContainerSelect>
              )}

              {/* <ButtonV2 
                  width='112px'
                  height='42px'
                  value='RELATÓRIO'
                  outline={!loadingRelatorio}
                  disabled={false}
                  onClick={() => handleClickRelatorio()}
                  loading={loadingRelatorio}
                  color="#21262f"
              /> */}

              <ButtonV2 
                  width={width > 479 ? '230px' : '150px'}
                  height='48px'
                  value={width > 479 ? 'ADICIONAR PROPRIEDADE' : 'ADICIONAR'}
                  outline={false}
                  disabled={isTotvs()}
                  onClick={() => { if(!isTotvs()) window.location.href = `/localdeaplicacao/add/${produtorIdFromUrl}`}}
                  loading={false}
                  imagePlus={true}
              />
            </S.ContainerButtons>

            <S.ContactsWrapper>
              <S.Contacts>
                <S.IconsWrapper>
                  {phone && (
                    <Tooltip
                      content={tooltipContentPhone}
                      animation="fade"
                      delay={[100, 100]}
                      arrow={true}
                      theme="light"
                      placement="bottom"
                    >
                      <img
                        src={IconTooltip}
                        alt="Tooltip Icon"
                        onClick={() => handleClick(phone)}
                        style={{ cursor: 'pointer' }}
                      />
                    </Tooltip>
                  )}

                  {actions.map((action) => {
                    if (action.id === 4) {
                      return (
                        <S.Button2 key={action.id} onClick={action.onClick}>
                          <S.Icon src={action.src} alt="Ícone de consulta" />

                          <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                            {width > 479 ? 'Dados Produtor' : 'Ver dados'}
                          </TaglineM>
                        </S.Button2>
                      );
                    }

                    if (action.disabled) return null;

                    let tooltipContent;
                    if (action.id === 1) tooltipContent = tooltipContentWhatsApp;
                    else if (action.id === 2) tooltipContent = tooltipContentLocation;
                    else if (action.id === 3) tooltipContent = tooltipContentEmail;

                    return (
                      <Tooltip
                        key={action.id}
                        content={tooltipContent}
                        animation="fade"
                        delay={[100, 100]}
                        arrow={true}
                        theme="light"
                        placement="bottom"
                      >
                        <img
                          src={action.src}
                          onClick={action.onClick}
                          alt={action.alt}
                          style={{ cursor: 'pointer' }}
                        />
                      </Tooltip>
                    );
                  })}

                </S.IconsWrapper>
              </S.Contacts>
            </S.ContactsWrapper>
          </>
        ) : (
          <>
            <S.ContainerButtons>
              {fazendas.length > 0 && (
                <S.ContainerSelect>
                  <ButtonList
                    id="farms"
                    width="100%"
                    legend={produtor}
                    options={fazendas}
                    onSelected={(e) => selectFarm(e)}
                    value={farm}
                  />
                </S.ContainerSelect>
              )}

              {/* <ButtonV2 
                  width='112px'
                  height='42px'
                  value='RELATÓRIO'
                  outline={!loadingRelatorio}
                  disabled={false}
                  onClick={() => handleClickRelatorio()}
                  loading={loadingRelatorio}
                  color="#21262f"
              /> */}

              <S.Contacts>
                <S.IconsWrapper>
                  {phone && (
                    <Tooltip
                      content={tooltipContentPhone}
                      animation="fade"
                      delay={[100, 100]}
                      arrow={true}
                      theme="light"
                      placement="bottom"
                    >
                      <img
                        src={IconTooltip}
                        alt="Tooltip Icon"
                        onClick={() => handleClick(phone)}
                        style={{ cursor: 'pointer' }}
                      />
                    </Tooltip>
                  )}

                  {actions.map((action) => {
                    if (action.id === 4) {
                      return (
                        <S.Button2 key={action.id} onClick={action.onClick}>
                          <S.Icon src={action.src} alt="Ícone de consulta" />

                          <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                            {width > 479 ? 'Dados Produtor' : 'Ver dados'}
                          </TaglineM>
                        </S.Button2>
                      );
                    }

                    if (action.disabled) return null;

                    let tooltipContent;
                    if (action.id === 1) tooltipContent = tooltipContentWhatsApp;
                    else if (action.id === 2) tooltipContent = tooltipContentLocation;
                    else if (action.id === 3) tooltipContent = tooltipContentEmail;

                    return (
                      <Tooltip
                        key={action.id}
                        content={tooltipContent}
                        animation="fade"
                        delay={[100, 100]}
                        arrow={true}
                        theme="light"
                        placement="bottom"
                      >
                        <img
                          src={action.src}
                          onClick={action.onClick}
                          alt={action.alt}
                          style={{ cursor: 'pointer' }}
                        />
                      </Tooltip>
                    );
                  })}

                </S.IconsWrapper>
              </S.Contacts>

              <ButtonV2 
                  width={width > 479 ? '230px' : '150px'}
                  height='48px'
                  value={width > 479 ? 'ADICIONAR PROPRIEDADE' : 'ADICIONAR'}
                  outline={false}
                  disabled={isTotvs()}
                  onClick={() => { if(!isTotvs()) window.location.href = `/localdeaplicacao/add/${produtorIdFromUrl}`}}
                  loading={false}
                  imagePlus={true}
              />
            </S.ContainerButtons>
          </>
        )}
        
      </S.Header>
    </S.Container>
  );
};

export default FarmHeader;